export type OpeningHourMode = 'booking' | 'order' | 'delivery' | 'restaurant' | 'takeaway'
export type OpeningHourSchedule = 'booking' | 'order' | 'delivery'

export interface DurationByPeople {
  people: number
  duration: number
}

export interface ChangeLogEntry {
  createdAt: string
  userName: string
  createdBy: string
  changes: Array<{ key: string; from: unknown; to: unknown }>
}

export interface OpeningHour {
  id: number
  documentId: string
  bookosId: string
  mode: OpeningHourMode
  special: boolean
  name?: string
  day: number
  open: number
  close: number
  openSec: number
  closeSec: number
  endDate?: string
  maxBookings: number
  maxGuests: number
  maxBookingsInterval: number
  maxGuestsInterval: number
  note?: string
  onlyCountOnlineBookings: boolean
  useDurationByPeople: boolean
  durationByPeople?: DurationByPeople[]
  seatingActive: boolean
  seatingInterval: number
  seatingDuration: number
  paymentActive: boolean
  useWaitlist: boolean
  changeLog?: ChangeLogEntry[]
  areas?: Array<{ id: number; name: string }>
  createdAt: string
  updatedAt: string
}

export function normalizeOpeningHourMode(mode: OpeningHourMode): OpeningHourSchedule {
  if (mode === 'restaurant') return 'booking'
  if (mode === 'takeaway') return 'order'
  return mode
}

export function openingHourMatchesSchedule(
  hour: Pick<OpeningHour, 'mode'>,
  schedule: OpeningHourSchedule,
): boolean {
  return normalizeOpeningHourMode(hour.mode) === schedule
}
